import { useEffect } from 'react';

/**
 * F2-6 / HP body scroll lock: Modal üst üste açılıp kapanınca body scroll
 * kayboluyordu (2 naive site kendi lock/unlock'larıyla çakışıyordu).
 * Ref-count'lu tek hook: en son modal kapandığında scroll geri gelir.
 */
const scrollLockCount = new Map();

export function useScrollLock(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const key = 'global';
    const current = scrollLockCount.get(key) || 0;
    scrollLockCount.set(key, current + 1);
    document.body.style.overflow = 'hidden';

    return () => {
      const now = scrollLockCount.get(key) || 1;
      if (now <= 1) {
        scrollLockCount.delete(key);
        document.body.style.overflow = '';
      } else {
        scrollLockCount.set(key, now - 1);
      }
    };
  }, [active]);
}

export default useScrollLock;
